import * as React from 'react'
import { IRiderTrip, ITripStatus } from '../../../types'
import Dots from '../../icons/ui/Dots'
import Edit from '../../icons/ui/Edit'
import Point from '../../icons/ui/Point'
import * as moment from 'moment'
import FormatTimeInTrip from '../../ui/FormatTimeInTrip'
import { TripStatuses } from '../../../constants/trip-statuses'
import { tripsStatuses } from 'src/state/constants'

interface ITripDetailLocationProps {
  riderTrip: IRiderTrip
  iTripStatus?: string
  getManyStatusesById: (tripId: string) => Promise<ITripStatus[]>
}

interface ITripDetailLocationState {
  status: ITripStatus[]
}

interface ILocation {
  fullAddress: string
  placeName?: string
  iconType: 'PICKUP' | 'DROPOFF' | 'ADDITIONALSTOP'
}

const Location = ({ fullAddress, iconType, placeName = '' }: ILocation) => {
  const icon = {
    PICKUP: 'svg-green',
    DROPOFF: 'svg-red',
    ADDITIONALSTOP: 'svg-blue'
  }
  return (
    <div className='flex fit relative pt1'>
      <div className='td-location-icon'>
        <Point className={`${icon[iconType]} fit`} />
      </div>
      {placeName && <p className='font-small m0 td-place-name'>{placeName}</p>}
      <p className={`font-small m0 ${placeName ? 'ml1' : ''}`}>{fullAddress}</p>
    </div>
  )
}

function TripDetailLocation(props: ITripDetailLocationProps, state: ITripDetailLocationState) {
  const { iTripStatus, riderTrip } = props
  const destinations =
    riderTrip !== undefined && riderTrip.destinations !== undefined
      ? riderTrip.destinations.sort((a, b) => (a.sequenceNo as number) - (b.sequenceNo as number))
      : []

  if (!riderTrip) {
    return null
  }

  const [status, setStatus] = React.useState<ITripStatus[]>([{ createdAt: new Date(), status: '' }])
  React.useEffect(() => {
    async function getStatuses() {
      const status = await props.getManyStatusesById(riderTrip.id)
      setStatus(status)
    }
    getStatuses()
  }, [])
  const arrivedAt = status.find(item => item.status === 'ARRIVED_AT_PICK_UP')
  const dropOff = status.find(item => item.status === 'ARRIVED_AT_DROP_OFF')
  const createdAt = arrivedAt ? moment(arrivedAt.createdAt).format('MMM DD, h:mm a') : ''
  const lastStatusAt = dropOff ? moment(dropOff.createdAt).format('MMM DD, h:mm a') : ''
  //Checking Driver Status
  const DriverStatus = iTripStatus === TripStatuses.DRIVER_CANCELLED || iTripStatus === TripStatuses.CANCELLED
  //Checking Driver Status
  const pickupLocationFullAddress: string = riderTrip.pickupLocation ? riderTrip.pickupLocation.fullAddress : ''
  const dropoffLocationFullAddress: string = riderTrip.dropoffLocation ? riderTrip.dropoffLocation.fullAddress : ''

  const originalPickAddr: string =
    riderTrip.details && riderTrip.details.originalPickAddr ? `${riderTrip.details.originalPickAddr}` : ''
  const originalDropAddr: string =
    riderTrip.details && riderTrip.details.originalDropAddr ? `${riderTrip.details.originalDropAddr}` : ''
  const pickUpNote: string = (riderTrip.details && riderTrip.details.pickUpNote) || ''
  const dropOffNote: string = (riderTrip.details && riderTrip.details.dropOffNote) || ''

  return (
    <div className='fit py2 px2'>
      <div className='flex flex-column'>
        {/* Pickup Location */}
        <Location
          fullAddress={pickupLocationFullAddress}
          iconType={'PICKUP'}
          placeName={riderTrip.pickupLocation && riderTrip.pickupLocation.placeName}
        />
        {riderTrip.pickupLocation && riderTrip.pickupLocation.notes && (
          <div className='flex fit relative'>
            <div className='col-6'>
              <p className='font-small m0' style={{ marginLeft: '25px' }}>{`${riderTrip.pickupLocation.notes}`}</p>
            </div>
          </div>
        )}
        {(createdAt || riderTrip.pickupLocation.phoneNumber) && (
          <div className='flex fit relative justify-end pt1'>
            {riderTrip.pickupLocation.phoneNumber && (
              <div className='col-6'>
                <p className='font-small m0' style={{ marginLeft: '25px' }}>
                  Phone: hellooooo
                </p>
              </div>
            )}
            {createdAt && (
              <div className='col-6'>
                <span className='font-small m0 ml2'>
                  <FormatTimeInTrip time={createdAt} />
                </span>
              </div>
            )}
          </div>
        )}
        {originalPickAddr && !pickupLocationFullAddress.startsWith(originalPickAddr) && (
          <div className='font-small pt1'>original address: {riderTrip.details.originalPickAddr}</div>
        )}
        {pickUpNote && <div className='font-small pt1'>note: {pickUpNote}</div>}
      </div>
      {/* Additional Stop Location */}
      {destinations &&
        destinations.length > 0 &&
        destinations.map((destination, key) => {
          if (
            destination.location !== undefined &&
            destination.location.placeName !== undefined &&
            destination.location.fullAddress !== undefined
          ) {
            const { fullAddress, placeName } = destination.location
            return <Location fullAddress={fullAddress} iconType={'ADDITIONALSTOP'} placeName={placeName} key={key} />
          } else {
            return <></>
          }
        })}
      {/* Dropoff Location */}
      <div className='flex flex-column'>
        <Location
          fullAddress={dropoffLocationFullAddress}
          iconType={'DROPOFF'}
          placeName={riderTrip.dropoffLocation && riderTrip.dropoffLocation.placeName}
        />
        <div className='flex fit relative'>
          <div className='col-6'>
            <p className='font-small m0' style={{ marginLeft: '25px' }}>
              {riderTrip.dropoffLocation ? riderTrip.dropoffLocation.notes : ''}
            </p>
          </div>
        </div>
        {(riderTrip.dropoffLocation || !DriverStatus) && (
          <div className='flex fit relative justify-end pt1'>
            {riderTrip.dropoffLocation.phoneNumber && (
              <div className='col-6'>
                <p className='font-small m0' style={{ marginLeft: '25px' }}>
                  Phone: {riderTrip.dropoffLocation.phoneNumber}
                </p>
              </div>
            )}
            {!DriverStatus && lastStatusAt && (
              <div className='col-6'>
                {/* Conditions and logics */}
                <span className='font-small m0 ml2'>
                  <FormatTimeInTrip time={lastStatusAt} />
                </span>
                {/* Conditions and logics */}
              </div>
            )}
          </div>
        )}
      </div>
      {originalDropAddr && !dropoffLocationFullAddress.startsWith(originalDropAddr) && (
        <div className='font-small pt1'>original address: {riderTrip.details.originalDropAddr}</div>
      )}
      {dropOffNote && <div className='font-small pt1'>note: {dropOffNote}</div>}
    </div>
  )
}

export default TripDetailLocation



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/location.tsx